<div [matTooltip]="'Sticky note'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-sticky-note'"
    (click)="stickyNoteMenuTrigger.openMenu(); onSelectStickyNote(defaultColor)"
  >
    <fa-icon [icon]="['fal', 'sticky-note']"></fa-icon>
    <div class="menu-trigger" #stickyNoteMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="stickyNoteMenu"></div>
  </button>
</div>

<mat-menu
  class="sticky-notes-menu-container"
  #stickyNoteMenu="matMenu"
  [overlapTrigger]="false"
  [backdropClass]="toolbarBackdropClass"
>
  <div class="sticky-notes-menu">
    <button
      mat-mini-fab
      *ngFor="let color of stickyNotesColors; trackBy: trackByValue"
      intercomTarget="toolbar-insert-sticky-{{ color }}"
      [style.backgroundColor]="color"
      (click)="onSelectStickyNote(color)"
    ></button>
  </div>
</mat-menu>
